import { createContext } from 'react';

export interface CampusFeatureFlags {
  // hasEv: boolean;
  hasBattery: boolean;
  // hasThermalZones: boolean;
  // hasSolar: boolean;
  // hasSingleGX: boolean;
}

export interface TimeRange {
  startTime: string | null;
  endTime: string | null;
}

export interface ControlMode {
  id: string;
  mode: string;
  isActive: boolean;
  untilDesc?: string;
  details?: string;
  duration?: TimeRange;
}

export interface ThermalZoneTactic {
  blockCode: string;
  endDateTime: string;
  startDateTime: string;
}

export interface CampusContextType {
  meta: {
    campusName: string;
    campusId: string;
  };
  featureFlags: CampusFeatureFlags;
  controlModes?: ControlMode[];
}

const defaultFeatureFlags: CampusFeatureFlags = {
  hasBattery: false,
};

export const defaultCampusContext: CampusContextType = {
  meta: {
    campusName: '',
    campusId: '',
  },
  featureFlags: defaultFeatureFlags,
  controlModes: [],
};

export const CampusContext = createContext<CampusContextType | undefined>(undefined);
